import React from 'react';
import {makeObservable} from 'mobx';
import {observer} from 'mobx-react';
import s from '../../s';
import DescMainContent from './desc-main-content';

type Props = {
    toggleExpandable: (e: React.KeyboardEvent<HTMLDivElement>, id: string) => void;
};

@observer
export default class DescMain extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
        makeObservable(this);
    }

    render() {
        if (!s.ready) {
            return;
        }

        return (
            <div id="prod-desc">
                <div
                    id="prod-main-desc"
                    className="prod-sub-header toggle-bs"
                    role="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#prod-main-desc-inner"
                    aria-expanded={false}
                    aria-controls="prod-main-desc-inner"
                    tabIndex={0}
                    onKeyDown={e => this.props.toggleExpandable(e, 'prod-main-desc')}
                >
                    Description
                </div>
                <div
                    style={{height: 'auto', maxHeight: 'inherit'}}
                    id="prod-main-desc-inner"
                    className="collapse show"
                >
                    {<DescMainContent />}
                </div>
            </div>
        );
    }
}
